(() => {
	const ACTIVE_ATTR = "active";
	const MAXIMUM_OPEN_HEIGHT = Number(getComputedStyle(document.documentElement).getPropertyValue('--info-block-max-height').replace('px', ''));
	const MAX_HEIGHT = "100%";
	const ATTR_TO_OBSERVE = "style";
	const RESIZABLE_CLASS = "resizable";

	const allSwatches = [...document.querySelectorAll('.swatch-size-info')];

	const reset = (removeListener) => {
		allSwatches.forEach(swatch => {
			swatch.style.height = `${MAXIMUM_OPEN_HEIGHT}px`;
			swatch.removeAttribute(ACTIVE_ATTR);

			if (removeListener) {
				swatch.removeEventListener('click', onClick);
			}
		});
	}

	const open = (swatch) => {
		swatch.style.height = `${swatch.scrollHeight}px`;
		swatch.setAttribute(ACTIVE_ATTR, "");
	}

	const onClick = (event) => {
		const swatch = event.currentTarget;
		const isCurrentlyActive = swatch.hasAttribute(ACTIVE_ATTR);

		if (isCurrentlyActive) {
			reset();
		} else {
			open(swatch);
		}
	}

	const onAttributeChange = () => {
		const currentlyShown = allSwatches.find(swatch => swatch.style.display !== 'none');

		if (!currentlyShown || !allSwatches.length) return;
		if (!currentlyShown.classList.contains(RESIZABLE_CLASS) && currentlyShown.scrollHeight > MAXIMUM_OPEN_HEIGHT) currentlyShown.classList.add(RESIZABLE_CLASS);
		else if (currentlyShown.classList.contains(RESIZABLE_CLASS) && currentlyShown.scrollHeight <= MAXIMUM_OPEN_HEIGHT) currentlyShown.classList.remove(RESIZABLE_CLASS);
		else currentlyShown.addEventListener('click', onClick);
	}

	const observer = new MutationObserver(onAttributeChange);

	allSwatches.forEach(swatch => {
		reset();
		swatch.style.maxHeight = MAX_HEIGHT;
		observer.observe(swatch, { attributes: true, attributeFilter: [ATTR_TO_OBSERVE] });
	});

	addEventListener('load', onAttributeChange);
})();